<template>
  <div>
    <page-header :title="$t('system.text_22')" :tabs="cloudEnvOptions" :current-tab.sync="cloudEnv" />
    <page-body>
      <list :cloud-env="cloudEnv" @result="handleResult" />
    </page-body>
  </div>
</template>

<script>
import List from './components/List'

export default {
  name: 'GlobalSettingIndex',
  components: {
    List,
  },
  data () {
    const opts = [
      { key: 'compute', label: this.$t('dictionary.compute') },
      { key: 'cloudenv', label: this.$t('cloudenv.text_8') },
      { key: 'bill', label: this.$t('scope.text_254') },
      { key: 'iam', label: this.$t('scope.text_959') },
      { key: 'system', label: this.$t('cloudenv.text_457') },
    ]
    return {
      opts,
      cloudEnv: 'compute',
      cloudEnvOptions: opts,
    }
  },
  methods: {
    handleResult (list) {
      this.cloudEnvOptions = this.opts.filter(item => list.includes(item.key))
      this.cloudEnv = this.cloudEnvOptions.length ? this.cloudEnvOptions[0].key : 'compute'
    },
  },
}
</script>
